import { render, staticRenderFns } from "./ComoTeEnteraste.vue?vue&type=template&id=2012f1b8&scoped=true"
import script from "./ComoTeEnteraste.vue?vue&type=script&lang=js"
export * from "./ComoTeEnteraste.vue?vue&type=script&lang=js"
import style0 from "./ComoTeEnteraste.vue?vue&type=style&index=0&id=2012f1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012f1b8",
  null
  
)

export default component.exports